<template>
  <a-modal title="影响用户列表" :visible="showTubeView" width="80%" destroyOnClose @ok="closeTubeView" @cancel="closeTubeView"
    :z-index="2000" :style="{ position: 'absolute', left: '18rem', top: '3rem' }">
    <a-button type="primary" style="margin-bottom: 8px" @click="exportHandle()" :loading="exportLoading">导出</a-button>
    <a-button type="primary"
      style="margin-bottom: 8px; margin-left: 10px; margin-right: 10px" @click="endmessages()" :loading="exportLoading" :disabled="!waterstopdisplay"
      v-action:sendmessages>短信指定发送</a-button>
    <a-button type="primary" style="margin-bottom: 8px" @click="sendAll()"
      :loading="exportLoading" :disabled="!waterstopdisplay" v-action:SendSMS>一键发送短信</a-button>
    <a-button type="primary" style="margin-bottom: 8px; margin-left: 10px"
      @click="openWxNoteModal" :disabled="!waterstopdisplay">发送微信通知</a-button>
      
    <a-table rowKey="id" :data-source="dataList"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :columns="columns"
      :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
    </a-table>
    <a-modal v-model="visible" title="提示" @ok="handleOk" :z-index="2020">
      <a-row>
        <a-col :span="8"> 请选择需要发送的人员 </a-col>
        <a-col :span="8">
          <a-checkbox v-model="SendSMSwith.isUser" @change="checkbox">受影响的用户</a-checkbox>
        </a-col>
        <a-col :span="8">
          <a-checkbox v-model="SendSMSwith.isWater" @change="checkbo">水司人员</a-checkbox>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal v-model="visibles" title="批量发送短信(区域停水管控)" :width="800" @ok="customSendNote" @cancel="SendSMSinbulkCancelh"
      :confirmLoading="sendSMSLoading" :okButtonProps="{ props: { disabled: sendSMSLoading } }"
      :z-index="2010">
      <a-form-model class="log-form" :model="SendSMSwith" ref="SendSMSwith" :rules="rules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }">
        <div v-if="this.isWaterdt">
          <a-form-model-item label="" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <h3>通知受影响的用户</h3>
          </a-form-model-item>
          <a-form-model-item label="短信模板" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="principal">
            <a-select v-model="SendSMSwith.principal" @change="handleChange" allow-clear :dropdown-style="{ zIndex: 2050 }">
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.templateName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="短信内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-textarea :disabled="isUserBody" placeholder="请输入发给所选用户的短信" v-model="SendSMSwith.userDto.body"
              :rows="3" />
          </a-form-model-item>
        </div>

        <div v-if="this.isWaterdty">
          <a-form-model-item label="" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <h3>通知水司人员</h3>
          </a-form-model-item>

          <a-form-model-item label="请选择需要发送的人员" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
            <a-checkbox v-model="isEventAdmin" @change="checkboxisEvent">事件管理员</a-checkbox>
            <a-checkbox v-model="isEventPrincipal" @change="checkboisEvent">事件负责人 </a-checkbox>
          </a-form-model-item>
          <a-form-model-item label="其他人员" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
            <a-button type="dashed" icon="plus" @click="openWaterUserModal">添加其他人员</a-button>
            <div v-if="selectedWaterUsers.length" style="margin-top: 8px;">
              <a-tag
                v-for="user in selectedWaterUsers"
                :key="user.id"
                closable
                @close="removeWaterUser(user)">
                {{ user.realName || user.username }}
              </a-tag>
            </div>
          </a-form-model-item>
          <a-form-model-item label="短信模板" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="assistPersons">
            <a-select show-search v-model="SendSMSwith.assistPersons" @change="handleChanget" allow-clear :dropdown-style="{ zIndex: 2050 }">
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.templateName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item v-if="!isWaterBody" label="事件单号" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }"
            prop="eventID">
            <a-input v-model="SendSMSwith.eventID" placeholder="请输入停水事件单号" />
          </a-form-model-item>
          <a-form-model-item label="短信内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-textarea :disabled="isWaterBody" placeholder="请输入发给所选用户的短信" v-model="SendSMSwith.waterDto.body"
              :rows="3" />
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal v-model="waterUserModalVisible" title="水司人员" :width="700" @cancel="closeWaterUserModal"
      :z-index="2030">
      <template slot="footer">
        <a-button @click="closeWaterUserModal">取消</a-button>
        <a-button type="primary" @click="confirmWaterUserSelection">确认</a-button>
      </template>
      <div class="water-user-modal">
        <a-form layout="inline" style="margin-bottom: 16px">
          <a-form-item label="用户名">
            <a-input v-model="waterUserQuery.username" placeholder="请输入用户名" allow-clear style="width: 140px" />
          </a-form-item>
          <a-form-item label="姓名">
            <a-input v-model="waterUserQuery.realName" placeholder="请输入姓名" allow-clear style="width: 140px" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="searchWaterUsers">查询</a-button>
            <a-button style="margin-left: 8px" @click="resetWaterUserQuery">重置</a-button>
          </a-form-item>
        </a-form>
        <a-table rowKey="id" :data-source="waterUserList" :columns="waterUserColumns" :loading="waterUserLoading"
          :row-selection="{ selectedRowKeys: waterUserSelectedKeys, onChange: onWaterUserSelectChange }"
          :pagination="waterUserPagination" @change="waterUserPageChange" size="small">
          <span slot="selectedStatus" slot-scope="text, record">
            <a-icon v-if="waterUserSelectedKeys.includes(record.id)" type="check-circle" style="color: #52c41a" />
          </span>
        </a-table>
      </div>
    </a-modal>
    <a-modal v-model="wxNoteVisible" title="发送微信通知" :width="1080" @ok="submitWxNote" :confirmLoading="wxNoteLoading" :okButtonProps="{ loading: wxNoteLoading }" :z-index="2030">
      <div class="wx-note-layout">
        <div class="wx-note-form">
          <a-form-model :model="wxNoteForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
            <a-form-model-item label="模板选择" required>
              <a-select v-model="wxNoteForm.id" placeholder="请选择" @change="handleWxTemplateChange" allow-clear :dropdown-style="{ zIndex: 2050 }">
                <a-select-option v-for="item in wxTemplateList" :key="item.id" :value="item.id">
                 {{ item.title || '-' }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="模板内容">
              <a-textarea :value="wxTemplateContentWithVars" :rows="6" disabled />
            </a-form-model-item>
            <a-form-model-item label="停水类型" required>
              <a-auto-complete
                v-model="wxNoteForm.waterCutType"
                :data-source="waterCutTypeOptions"
                placeholder="请选择或输入停水类型"
                allow-clear
                @change="handleWaterCutTypeChange"
                :filter-option="filterWaterCutTypeOption"
                :dropdown-style="{ zIndex: 2050 }"
                :get-popup-container="(trigger) => trigger.parentNode"
              />
            </a-form-model-item>
            <a-form-model-item label="停水原因" required>
              <a-input
                v-model="wxNoteForm.waterReason"
                placeholder="请输入停水原因"
              />
            </a-form-model-item>
            <a-form-model-item label="停水时间" required>
              <a-input
                v-model="wxNoteForm.waterCutTime"
                placeholder="请输入停水时间"
              />
            </a-form-model-item>
            <a-form-model-item label="停水区域" required>
              <a-textarea v-model="wxNoteForm.waterCutRegion" :rows="6" placeholder="请输入停水区域" />
            </a-form-model-item>
            <a-form-model-item label="温馨提示">
              <a-textarea v-model="wxNoteForm.warmTips" :rows="4" />
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="wx-phone-panel">
          <div class="wx-phone-shell">
            <div class="wx-phone-notch"></div>
            <div class="wx-phone-screen">
              <div class="wx-status-bar">
                <div class="wx-status-left">
                  <span>●●●●○</span>
                  <svg style="width:12px;height:12px;margin-left:4px" viewBox="0 0 24 24"><path fill="#333" d="M12 3C6.5 3 2 6 2 6l10 13L22 6s-4.5-3-10-3z"/></svg>
                </div>
                <div class="wx-status-center">6:00 PM</div>
                <div class="wx-status-right">
                  <span>100%</span>
                  <svg style="width:18px;height:10px;margin-left:4px" viewBox="0 0 24 24"><path fill="#333" d="M2 5h18v14H2V5zm20 4h2v6h-2V9zM4 7v10h14V7H4z"/></svg>
                </div>
              </div>
              <div class="wx-top-title-bar">
                <span class="wx-top-back">×</span>
                <span class="wx-top-title">停水通知</span>
                <span class="wx-top-more">···</span>
              </div>
              <div class="wx-card wx-notice-card">
                <div class="wx-notice-header">停 水 通 知</div>
                <div class="wx-user-title">尊敬的用户：</div>
                <div class="wx-intro">{{ wxNoteForm.waterReason  }}</div>
                <div class="wx-detail-item">
                  <span class="wx-detail-label">停水类型：</span>
                  <span class="wx-detail-value">{{ wxNoteForm.waterCutType || '-' }}</span>
                </div>
                <div class="wx-detail-item">
                  <span class="wx-detail-label">停水时间：</span>
                  <span class="wx-detail-value">{{ wxNoteForm.waterCutTime || '-' }}</span>
                </div>
                <div class="wx-detail-item">
                  <span class="wx-detail-label">停水区域：</span>
                  <span class="wx-detail-value">{{ wxNoteForm.waterCutRegion || '-' }}</span>
                </div>
                <div class="wx-signature">
                  <div class="wx-sign-company">xx自来水公司</div>
                  <div class="wx-sign-date">{{ moment().format('YYYY年M月D日') }}</div>
                </div>
              </div>
              <div class="wx-card wx-tips-card">
                <div class="wx-section-header">
                  <div class="wx-section-icon">
                    <svg viewBox="0 0 24 24"><path d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.06 3.06 6.06 12 11.997 8.94-5.937 12-7.937 12-11.997 0-8.165-10.011-9.041-12-3.568z"/></svg>
                  </div>
                  <span class="wx-tips-title">温馨提示</span>
                </div>
                <div class="wx-tips-content">{{ wxNoteForm.warmTips || '暂无提示内容' }}</div>
              </div>
              <div class="wx-card wx-contact-card">
                <div class="wx-section-header">
                  <div class="wx-section-icon">
                    <svg viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 12c2.209 0 4-1.791 4-4s-1.791-4-4-4-4 1.791-4 4 1.791 4 4 4zm0 2c-2.674 0-8 1.356-8 4v2h16v-2c0-2.644-5.326-4-8-4z"/></svg>
                  </div>
                  <span class="wx-contact-title">关注我们</span>
                </div>
                <div class="wx-contact-body">
                  <div class="wx-contact-info">
                    <div class="wx-contact-company">xx自来水公司</div>
                    <div class="wx-contact-line">电话：xx</div>
                    <div class="wx-contact-line">地址：xx</div>
                  </div>
                  <div class="wx-qrcode-box">
                    <div class="wx-qrcode-placeholder">
                      <svg viewBox="0 0 24 24" style="width: 24px; height: 24px; fill: #d9d9d9;"><path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm13-2h3v2h-3v-2zm-2 2h2v2h-2v-2zm-2 2h2v2h-2v-2zm4 0h3v4h-3v-4zm-2 2h2v2h-2v-2zm-4-4h2v2h-2v-2zm0 4h2v2h-2v-2z"/></svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wx-phone-home"></div>
          </div>
        </div>
      </div>
    </a-modal>
  </a-modal>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import { getAliyunTemplates,getSysUserMsg, addOrUpdateSysUserMsg  } from '@/api/aliyunSms'
import { selectWxTemplateByTenantId } from '@/api/serviceConfig'
 export default {
  data () {
    return {
      isUserBody: true,
      isWaterBody: true,
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName'
        },
        {
          title: '分类编码',
          dataIndex: 'classNo'
        },
        {
          title: '水表编号',
          dataIndex: 'appearanceNo'
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName'
        },
        {
          title: '用户地址',
          dataIndex: 'address'
        },
        {
          title: '手机号',
          dataIndex: 'phone'
        },
        {
          title: '安装时间',
          dataIndex: 'installDate'
        },
        {
          title: '口径',
          dataIndex: 'caliber'
        },
        {
          title: '品牌',
          dataIndex: 'brand'
        },
        {
          title: '类型',
          dataIndex: 'type'
        },
        {
          title: '状态',
          dataIndex: 'status'
        },
        {
          title: '用户用水类型',
          dataIndex: 'waterBigStatus',
          scopedSlots: { customRender: 'waterBigStatus' }
        }
      ],
      SendSMSwith: {
        lineId: '',
        classNos: '',
        gisClassIds: [],
        isUser: true,
        isWater: true,
        principal: '',
        assistPersons: '',
        userDto: {
          id: '',
          body: ''
        },
        eventID: '',
        waterDto: {
          id: '',
          body: '',
          isEventAdmin: true,
          isEventPrincipal: true
        }
      },
      userlist: [],
      waterstopdisplay: false,

      isEventAdmin: true,
      isEventPrincipal: true,
      queryUrl: 'pipe-network/gis_class_user_water_meters/page',
      dataList: [],
      selectedRows: [],
      dataListLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/gis_class_user_water_meters/export',
      exportLoading: false,
      showTubeView: false,
      visible: false,
      visibles: false,
      sendSMSLoading: false,
      isWaterdt: true,
      isWaterdty: true,
      id: '',
      currentId: '',
      idList: '',
      // 同一批分类编号 + 总条数不变时，全量 id 接口只请求一次
      idListFetchKey: '',
      rules: {
        principal: [{ required: true, message: '请选择短信模板名称', trigger: 'change' }],
        assistPersons: [{ required: true, message: '请选择短信模板名称', trigger: 'change' }],
        eventID: [{ required: true, message: '请输入停水事件单号', trigger: 'blur' }]
      },
      waterUserModalVisible: false,
      selectedWaterUsers: [],
      linkedWaterEvents: [],
      waterUserList: [],
      waterUserLoading: false,
      waterUserSelectedKeys: [],
      waterUserSelectedMap: {},
      waterUserQuery: {
        username: '',
        realName: ''
      },
      waterUserPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`
      },
      waterUserColumns: [
        { title: '用户名', dataIndex: 'username' },
        { title: '姓名', dataIndex: 'realName' },
        { title: '部门', dataIndex: 'deptName' },
        { title: '选中状态', key: 'selectedStatus', scopedSlots: { customRender: 'selectedStatus' } }
      ],
      wxNoteVisible: false,
      wxNoteLoading: false,
      wxTemplateList: [],
      waterCutTypeOptions: ['紧急停水', '计划停水', '延长时段停水'],
      waterReasonMap: {
        紧急停水: '因（xx地方）突发爆管，紧急停水抢修。',
        计划停水: '因管网检修，计划停水。',
        延长时段停水: '因施工难度增加，需延长停水时间。'
      },
      lastAutoWaterReason: '',
      defaultwarmTips: '  请用户提前做好储水准备,并关闭水龙头、闸阀。恢复供水后自来水可能短暂浑浊为正常现象，只需打开水龙头排水，待自来水清澈即可正常用水。给您带来不便，敬请谅解！24小时服务热线：0735-8223715',
      wxNoteForm: {
        id: '',
        title: '',
        content: '',
        waterCutType: '',
        waterReason: '',
        waterCutTime: '',
        waterCutRegion: '',
        warmTips: ''
      }
    }
  },
  computed: {
    // 替换微信模板变量后的内容
    wxTemplateContentWithVars () {
      let content = this.wxNoteForm.content || ''
      const { waterCutType, waterReason, waterCutTime, waterCutRegion, warmTips } = this.wxNoteForm
      const hasK5 = /\{\{keyword5\.DATA\}\}/.test(content)
      const hasK4 = /\{\{keyword4\.DATA\}\}/.test(content)
      // 含 keyword4/5：按完整停水通知模板 keyword1~5（类型、原因、时间、区域、温馨提示）
      if (hasK4 || hasK5) {
        if (waterCutType) {
          content = content.replace(/\{\{keyword1\.DATA\}\}/g, waterCutType)
        }
        if (waterReason) {
          content = content.replace(/\{\{keyword2\.DATA\}\}/g, waterReason)
        }
        if (waterCutTime) {
          content = content.replace(/\{\{keyword3\.DATA\}\}/g, waterCutTime)
        }
        if (waterCutRegion) {
          content = content.replace(/\{\{keyword4\.DATA\}\}/g, waterCutRegion)
        }
        if (warmTips) {
          content = content.replace(/\{\{keyword5\.DATA\}\}/g, warmTips)
        }
        return content
      }
      // 仅 keyword1~3：与 notemanage/wx-push-notice 一致（类型、时间、区域），停水原因不进模板占位符
      if (waterCutType) {
        content = content.replace(/\{\{keyword1\.DATA\}\}/g, waterCutType)
      }
      if (waterCutTime) {
        content = content.replace(/\{\{keyword2\.DATA\}\}/g, waterCutTime)
      }
      if (waterCutRegion) {
        content = content.replace(/\{\{keyword3\.DATA\}\}/g, waterCutRegion)
      }
      return content
    }
  },
  methods: {
    getPrimaryLinkedWaterEvent () {
      return this.linkedWaterEvents && this.linkedWaterEvents.length > 0
        ? this.linkedWaterEvents[0]
        : null
    },
    getWaterCutRegionByEvent (event) {
      if (!event) return ''
      return event.waterCutRegion || event.outageArea || event.address || event.region || event.area || ''
    },
    filterWaterCutTypeOption (input, option) {
      if (input === undefined || input === null || String(input).trim() === '') return true
      const q = String(input).trim()
      let text = ''
      if (typeof option === 'string') {
        text = option
      } else if (option && typeof option === 'object') {
        text = option.value != null ? String(option.value) : (option.text != null ? String(option.text) : '')
      }
      return text.indexOf(q) >= 0
    },
    moment,
    // 导出
    exportHandle () {
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: {
          analyzeData: true,
          classNos: this.id,
          // geophysicalPointNumber: 'JS581',
          page: this.pagination.current,
          limit: this.pagination.pageSize
        },
        headers: {
          Authorization: token
        }
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getDataList()
    },
    edit (id, pipeLineLayerId, outage, linkedWaterEvents = []) {
      this.idListFetchKey = ''
      this.idList = []
      // 保存关联的停水事件数据，用于短信模板变量替换
      this.linkedWaterEvents = linkedWaterEvents || []
      if (Array.isArray(linkedWaterEvents)) {
        this.waterstopdisplay = linkedWaterEvents.length > 0
      } else {
        this.waterstopdisplay = outage === '停水管控'
      }
      console.log(id, 'idsw', pipeLineLayerId)
      // this.SendSMSwith.gisClassIds = arrIdList
      this.SendSMSwith.classNos = id
      this.SendSMSwith.lineId = pipeLineLayerId
      this.showTubeView = true
      if (id) {
        this.id = id
        this.getDataList()
        this.$nextTick(() => {
          this.pagination.current = 1
        })
      }
    },
    SendSMSwithoneclick () {
      this.visible = true
    },
    checkbox (value) {
      this.SendSMSwith.isUser = value.target.checked
    },
    checkbo (value) {
      this.SendSMSwith.isWater = value.target.checked
    },
    checkboxisEvent (value) {
      this.SendSMSwith.waterDto.isEventAdmin = value.target.checked
    },
    checkboisEvent (value) {
      this.SendSMSwith.waterDto.isEventPrincipal = value.target.checked
    },
    handleOk () {
      if (this.SendSMSwith.isUser === true || this.SendSMSwith.isWater === true) {
        if (this.SendSMSwith.isUser === false) {
          this.isWaterdt = false
        } else {
          this.isWaterdt = true
        }
        if (this.SendSMSwith.isWater === false) {
          this.isWaterdty = false
        } else {
          this.isWaterdty = true
        }
        this.visibles = true
        this.visible = false // 关闭提示弹窗
        getAliyunTemplates({ ispage: 1 }).then((res) => {
          const rows = res?.rows || []
          const flat = rows.flatMap(r => r.aliyunTemplateVos || [])
          this.userlist = (flat || []).map(t => ({
            id: t.id,
            templateName: t.templateName,
            templateBody: t.templateContent || t.templateBody,
            templateCode: t.templateCode
          }))
          this.loadSavedWaterUserSelection()
        }).catch((error) => {
          console.error('获取短信模板列表失败:', error)
          this.$message.error('获取短信模板列表失败')
        })
      } else {
        return this.$message.info('请至少选择-种需要发送短信的人员！')
      }
    },
    filterOption (input, option) {
      return option.componentOptions
    },
    // 获取短信模板内容并替换停水事件变量
    getSmsTemplateContent (templateBody) {
      if (!templateBody) return ''
      // 获取第一个关联的停水事件数据用于替换变量
      const event = this.linkedWaterEvents && this.linkedWaterEvents.length > 0
        ? this.linkedWaterEvents[0]
        : null
      if (!event) return templateBody
      // 替换变量：${event_no}、${event_name}、${s_time}、${e_time}
      let content = templateBody
      if (event.eventNo) {
        content = content.replace(/\$\{event_no\}/g, event.eventNo)
      }
      if (event.eventName) {
        content = content.replace(/\$\{event_name\}/g, event.eventName)
      }
      if (event.planStartTime) {
        content = content.replace(/\$\{s_time\}/g, event.planStartTime)
      }
      if (event.planEntTime) {
        content = content.replace(/\$\{e_time\}/g, event.planEntTime)
      }
      return content
    },
    handleChanget (value) {
      if (value !== 999) {
        this.currentId = value
        this.isWaterBody = true
        // 从本地列表同步获取模板内容，并替换变量
        const template = this.userlist.find(item => String(item.id) === String(value))
        this.SendSMSwith.waterDto.body = this.getSmsTemplateContent(template?.templateBody)
        this.SendSMSwith.waterDto.id = value
      } else {
        this.SendSMSwith.waterDto.body = ''
        this.SendSMSwith.waterDto.id = 999
        this.isWaterBody = false
      }
    },
    handleChange (value) {
      if (value !== 999) {
        this.currentId = value
        this.isUserBody = true
        // 从本地列表同步获取模板内容，并替换变量
        const template = this.userlist.find(item => String(item.id) === String(value))
        this.SendSMSwith.userDto.body = this.getSmsTemplateContent(template?.templateBody)
        this.SendSMSwith.userDto.id = value
      } else {
        this.SendSMSwith.userDto.body = ''
        this.SendSMSwith.userDto.id = 999
        this.isUserBody = false
      }
    },
    customSendNote () {
      if (this.sendSMSLoading) return
      if (this.SendSMSwith.principal !== 999) {
        this.SendSMSinbulkOk('/pipe-network/gis_class_user_water_meters/influence/note')
      } else {
        this.SendSMSinbulkOk('/pipe-network/gis_class_user_water_meters/custom/sendSms')
      }
    },
    SendSMSinbulkOk (url) {
      if (this.sendSMSLoading) return

      this.$refs.SendSMSwith.validate((valid) => {
        if (valid) {
          this.sendSMSLoading = true
          this.saveWaterUserSelection()
          this.$http
            .post(url, { ...this.SendSMSwith })
            .then((res) => {
              if (res.code === 0) {
                this.selectedRows = []
                this.SendSMSwith.gisClassIds = []
                this.visibles = false
                this.visible = false
                this.SendSMSwith.userDto.body = ''
                this.SendSMSwith.waterDto.body = ''
                this.isUserBody = true
                this.isWaterBody = true
                this.SendSMSwith.eventID = ''
                this.SendSMSwith.principal = ''
                this.SendSMSwith.assistPersons = ''
                this.SendSMSwith.isUser = true
                this.SendSMSwith.isWater = true
                return this.$message.success('发送成功！')
              } else {
                this.selectedRows = []
                this.SendSMSwith.gisClassIds = []
                this.visibles = false
                this.visible = false
                this.SendSMSwith.userDto.body = ''
                this.SendSMSwith.waterDto.body = ''
                this.isUserBody = true
                this.isWaterBody = true
                this.SendSMSwith.eventID = ''
                this.SendSMSwith.principal = ''
                this.SendSMSwith.assistPersons = ''
                this.SendSMSwith.isUser = true
                this.SendSMSwith.isWater = true
                return this.$message.info('发送失败！')
              }
            })
            .finally(() => {
              this.sendSMSLoading = false
            })
        }
      })
    },
    SendSMSinbulkCancelh () {
      this.selectedRows = []
      this.SendSMSwith.gisClassIds = []
      this.visibles = false
      this.visible = false
      this.SendSMSwith.isUser = true
      this.SendSMSwith.isWater = true
      this.SendSMSwith.userDto.body = ''
      this.SendSMSwith.waterDto.body = ''
      this.SendSMSwith.eventID = ''
      this.SendSMSwith.principal = ''
      this.SendSMSwith.assistPersons = ''
    },
    endmessages () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要发送的短信')
      } else {
        this.SendSMSwith.gisClassIds = this.selectedRows
        this.SendSMSwithoneclick()
      }
    },
    sendAll () {
      this.SendSMSwith.gisClassIds = this.idList
      this.SendSMSwithoneclick()
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRows = selectedRowKeys
    },
    // 跳转到对应阀门
    jumpFather (record) {
      this.closeTubeView()
      this.$emit('jumpFather', record)
    },
    // 获取数据
    getDataList () {
      this.dataListLoading = true
      const params = {
        classNos: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.$http
        .post('/pipe-network/gis_class_user_water_meters/incidence/user', params)
        .then(({ data }) => {
          console.log(data, 'data')          
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
          this.ensureIdListLoaded()
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 分页列表拉取后：全量 id 在同一 classNos + total 下只请求一次（翻页不重复打 all 接口）
    ensureIdListLoaded () {
      const total = this.pagination.total
      if (!total) {
        this.idList = []
        this.idListFetchKey = `${this.id}|0`
        return
      }
      const key = `${this.id}|${total}`
      if (this.idListFetchKey === key) {
        return
      }
      this.getDataListIdList(key)
    },
    getDataListIdList (fetchKey) {
      const params = {
        classNos: this.id,
        page: 1,
        limit: this.pagination.total
      }
      this.$http
        .post('/pipe-network/gis_class_user_water_meters/all/incidence/user', params)
        .then(({ data }) => {
          console.log(data, 'dataall')
          const arrIdList = []
          data.map((item) => {
            return arrIdList.push(item.id)
          })
          this.idList = arrIdList
          this.idListFetchKey = fetchKey
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView () {
      this.showTubeView = false
      this.idListFetchKey = ''
      this.selectedRows = []
      this.SendSMSwith.isUser = true
      this.SendSMSwith.isWater = true
    },
    openWaterUserModal () {
      this.waterUserModalVisible = true
      this.waterUserSelectedKeys = this.selectedWaterUsers.map(u => u.id)
      this.waterUserSelectedMap = this.selectedWaterUsers.reduce((m, u) => {
        m[u.id] = u
        return m
      }, {})
      this.loadWaterUsers()
    },
    closeWaterUserModal () {
      this.waterUserModalVisible = false
      this.waterUserSelectedKeys = []
    },
    loadWaterUsers () {
      this.waterUserLoading = true
      const params = {
        orderColumn: '',
        orderType: 'asc',
        username: this.waterUserQuery.username || '',
        status: '',
        tenantId: '',
        deptId: '',
        condition: this.waterUserQuery.realName || '',
        page: this.waterUserPagination.current,
        limit: this.waterUserPagination.pageSize
      }
      this.$http
        .get('/manager/users/page', { params })
        .then(({ data }) => {
          this.waterUserLoading = false
          this.waterUserList = data.list || []
          this.waterUserPagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.waterUserLoading = false
        })
    },
    searchWaterUsers () {
      this.waterUserPagination.current = 1
      this.loadWaterUsers()
    },
    resetWaterUserQuery () {
      this.waterUserQuery.username = ''
      this.waterUserQuery.realName = ''
      this.waterUserPagination.current = 1
      this.loadWaterUsers()
    },
    waterUserPageChange (pagination) {
      this.waterUserPagination.current = pagination.current
      this.waterUserPagination.pageSize = pagination.pageSize
      this.loadWaterUsers()
    },
    onWaterUserSelectChange (selectedRowKeys, selectedRows) {
      this.waterUserSelectedKeys = selectedRowKeys
      const keysSet = new Set(selectedRowKeys.map(k => String(k)))
      selectedRows.forEach(row => {
        this.waterUserSelectedMap[row.id] = row
      })
      selectedRowKeys.forEach(id => {
        if (!this.waterUserSelectedMap[id]) {
          const user = this.waterUserList.find(u => String(u.id) === String(id))
          if (user) this.waterUserSelectedMap[id] = user
        }
      })
      Object.keys(this.waterUserSelectedMap).forEach(id => {
        if (!keysSet.has(String(id))) {
          delete this.waterUserSelectedMap[id]
        }
      })
    },
    confirmWaterUserSelection () {
      this.selectedWaterUsers = this.waterUserSelectedKeys
        .map(id => this.waterUserSelectedMap[id])
        .filter(Boolean)
      this.SendSMSwith.waterIds = this.selectedWaterUsers.map(u => u.id)
      this.closeWaterUserModal()
    },
    async loadSavedWaterUserSelection () {
      try {
        const res = await getSysUserMsg()
        const result =  res?.data
        if (!result) return
        // 恢复模板选择（弹窗打开时可能返回上次记录）
        if (result.userTemplateId && this.userlist.length > 0) {
          const tpl = this.userlist.find(t => String(t.id) === String(result.userTemplateId))
          if (tpl) {
            this.SendSMSwith.principal = tpl.id
            this.SendSMSwith.userDto.body = this.getSmsTemplateContent(tpl.templateBody || tpl.templateContent || '')
            this.SendSMSwith.userDto.id = tpl.id
          }
        }
        if (result.waterTemplateId && this.userlist.length > 0) {
          const tpl = this.userlist.find(t => String(t.id) === String(result.waterTemplateId))
          if (tpl) {
            this.SendSMSwith.assistPersons = tpl.id
            this.SendSMSwith.waterDto.body = this.getSmsTemplateContent(tpl.templateBody || tpl.templateContent || '')
            this.SendSMSwith.waterDto.id = tpl.id
          }
        }
        // 恢复人员选择
        if (!result.userIds) return
        let userIds = result.userIds
        if (typeof userIds === 'string') {
          userIds = userIds ? userIds.split(',').map(s => s.trim()).filter(Boolean) : []
        } else if (Array.isArray(userIds)) {
          userIds = userIds.map(id => String(id))
        } else {
          return
        }
        if (userIds.length === 0) return
        const { data } = await this.$http.get('/manager/users/list')
        const allUsers = data || []
        this.selectedWaterUsers = userIds
          .map(id => allUsers.find(u => String(u.id) === String(id)))
          .filter(Boolean)
        this.SendSMSwith.waterIds = this.selectedWaterUsers.map(u => u.id)
      } catch (e) {
        console.error('加载人员选择记录失败:', e)
      }
    },
    async saveWaterUserSelection () {
      const userIds = this.SendSMSwith.waterIds || []
      const userTemplateId = this.SendSMSwith.principal || ''
      const waterTemplateId = this.SendSMSwith.assistPersons || ''
      if (!userTemplateId && !waterTemplateId) return
      try {
        await addOrUpdateSysUserMsg({
          userIds,
          userTemplateId,
          waterTemplateId
        })
      } catch (e) {
        console.error('保存人员选择记录失败:', e)
      }
    },
    removeWaterUser (user) {
      this.selectedWaterUsers = this.selectedWaterUsers.filter(u => u.id !== user.id)
      this.SendSMSwith.waterIds = this.selectedWaterUsers.map(u => u.id)
    },
    openWxNoteModal () {
      const event = this.getPrimaryLinkedWaterEvent()
      this.wxNoteVisible = true
      this.wxNoteForm = {
        id: '',
        title: '',
        content: '',
        waterCutType: event?.waterCutType || event?.outageType || '',
        waterReason: '',
        waterCutTime: '',
        waterCutRegion: this.getWaterCutRegionByEvent(event),
        warmTips: this.defaultwarmTips
      }
      this.lastAutoWaterReason = ''
      this.loadWxTemplateList()
    },
    loadWxTemplateList () {
      selectWxTemplateByTenantId({ ispage: 1, pageNum: 1, pageSize: 100 }).then((res) => {
        if (res.code === 0) {
          this.wxTemplateList = res.rows || res.data?.rows || res.data || []
        } else {
          this.wxTemplateList = []
          this.$message.error(res.message || '获取微信模板失败')
        }
      }).catch(() => {
        this.wxTemplateList = []
        this.$message.error('获取微信模板失败')
      })
    },
    handleWaterCutTypeChange (value) {
      const reason = this.waterReasonMap[value] || ''
      // 切换类型时直接覆盖停水原因
      this.wxNoteForm.waterReason = reason
    },
    handleWxTemplateChange (value) {
      const current = this.wxTemplateList.find(item => String(item.id) === String(value))
      this.wxNoteForm.title = current?.title || current?.templateName || ''
      this.wxNoteForm.content = current?.content || ''
    },
    submitWxNote () {
      if (!this.wxNoteForm.id || !this.wxNoteForm.waterCutType || !this.wxNoteForm.waterReason || !this.wxNoteForm.waterCutTime || !this.wxNoteForm.waterCutRegion) {
        this.$message.warning('请完整填写微信通知参数')
        return
      }
      this.wxNoteLoading = true
      const payload = {
        lineId: this.SendSMSwith.lineId,
        waterCutType: this.wxNoteForm.waterCutType,
        waterReason: this.wxNoteForm.waterReason,
        waterCutTime: this.wxNoteForm.waterCutTime,
        waterCutRegion: this.wxNoteForm.waterCutRegion,
        warmTips: this.wxNoteForm.warmTips,
        id: this.wxNoteForm.id
      }
      this.$http.post('/pipe-network/gis_class_user_water_meters/influence/wxnote', payload).then((res) => {
        const code = res?.code ?? res?.data?.code
        const msg = res?.msg ?? res?.data?.msg ?? res?.message ?? res?.data?.message
        if (code === 0) {
          this.$message.success(msg || '微信通知发送成功')
          this.wxNoteVisible = false
        } else {
          this.$message.error(msg || '微信通知发送失败')
        }
      }).catch(() => {
        this.$message.error('微信通知发送失败')
      }).finally(() => {
        this.wxNoteLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wx-note-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.wx-note-form {
  flex: 0 0 calc(100% - 300px);
  max-width: calc(100% - 300px);
}

.wx-phone-panel {
  flex: 0 0 310px;
  width: 310px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  position: sticky;
  top: 0;
}

.wx-phone-shell {
  width: 260px;
  height: 540px;
  border-radius: 40px;
  background: linear-gradient(145deg, #2a2a2a 0%, #1a1a1a 100%);
  padding: 12px;
  position: relative;
  box-shadow: 
    0 0 0 2px #3a3a3a,
    0 0 0 4px #1a1a1a,
    0 20px 50px rgba(0, 0, 0, 0.4),
    0 8px 20px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

/* 侧边按钮 - 左侧音量键 */
.wx-phone-shell::before {
  content: '';
  position: absolute;
  left: -3px;
  top: 100px;
  width: 3px;
  height: 30px;
  background: linear-gradient(180deg, #3a3a3a 0%, #2a2a2a 100%);
  border-radius: 2px 0 0 2px;
  box-shadow: inset -1px 0 1px rgba(0, 0, 0, 0.3);
}

/* 侧边按钮 - 左侧静音键 */
.wx-phone-shell::after {
  content: '';
  position: absolute;
  left: -3px;
  top: 60px;
  width: 3px;
  height: 20px;
  background: linear-gradient(180deg, #3a3a3a 0%, #2a2a2a 100%);
  border-radius: 2px 0 0 2px;
  box-shadow: inset -1px 0 1px rgba(0, 0, 0, 0.3);
}

/* 右侧电源键 */
.wx-phone-panel::before {
  content: '';
  position: absolute;
  right: -3px;
  top: 110px;
  width: 3px;
  height: 45px;
  background: linear-gradient(180deg, #3a3a3a 0%, #2a2a2a 100%);
  border-radius: 0 2px 2px 0;
  box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.3);
}

.wx-phone-notch {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 28px;
  background: #1a1a1a;
  border-radius: 0 0 18px 18px;
  z-index: 10;
}

/* 听筒 */
.wx-phone-notch::before {
  content: '';
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 45px;
  height: 4px;
  background: linear-gradient(180deg, #0a0a0a 0%, #2a2a2a 100%);
  border-radius: 2px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.8);
}

/* 前置摄像头 */
.wx-phone-notch::after {
  content: '';
  position: absolute;
  top: 6px;
  right: 18px;
  width: 10px;
  height: 10px;
  background: radial-gradient(circle at 30% 30%, #3a3a3a 0%, #0a0a0a 100%);
  border-radius: 50%;
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.8), 0 0 1px rgba(255, 255, 255, 0.1);
}

.wx-phone-screen {
  height: 100%;
  background: #f7f8fa;
  border-radius: 32px;
  overflow: auto;
  padding: 40px 12px 20px;
  scrollbar-width: thin;
  scrollbar-color: #c7d2e6 transparent;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
}

.wx-phone-screen::-webkit-scrollbar {
  width: 4px;
}

.wx-phone-screen::-webkit-scrollbar-track {
  background: transparent;
}

.wx-phone-screen::-webkit-scrollbar-thumb {
  background: #c7d2e6;
  border-radius: 4px;
}

.wx-phone-screen::-webkit-scrollbar-thumb:hover {
  background: #9fb3d6;
}

.wx-phone-home {
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.wx-status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  color: #333;
  margin-bottom: 6px;
  padding: 0 4px;
}

.wx-status-left, .wx-status-right {
  display: flex;
  align-items: center;
  gap: 2px;
}

.wx-status-left span {
  letter-spacing: 1px;
}

.wx-status-center {
  font-weight: 600;
  font-size: 11px;
}

.wx-top-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2px 2px 8px;
  color: #6e7684;
}

.wx-top-back,
.wx-top-more {
  width: 22px;
  text-align: center;
  font-size: 16px;
  line-height: 1;
}

.wx-top-title {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #2f4058;
}

.wx-card {
  background: #fff;
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 8px 22px rgba(17, 73, 146, 0.06);
  border: 1px solid #edf1f7;
}

.wx-notice-card {
  background: linear-gradient(180deg, #f8fbff 0%, #f1f7ff 100%);
}

.wx-notice-header {
  text-align: center;
  background: #eaf3ff;
  color: #1489ff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
  padding: 8px 6px;
  margin-bottom: 12px;
}

.wx-user-title {
  font-size: 13px;
  font-weight: 600;
  color: #2b3440;
  margin-bottom: 6px;
}

.wx-intro {
  font-size: 12px;
  line-height: 1.75;
  color: #4f5966;
  margin-bottom: 10px;
  text-indent: 2em;
  text-align: justify;
}

.wx-detail-item {
  display: flex;
  margin-bottom: 6px;
  font-size: 12px;
}

.wx-detail-label {
  min-width: 62px;
  color: #566170;
  font-weight: 600;
}

.wx-detail-value {
  flex: 1;
  color: #3b4654;
  word-break: break-all;
}

.wx-signature {
  margin-top: 12px;
  text-align: right;
  color: #5b6572;
}

.wx-sign-company {
  font-size: 12px;
  margin-bottom: 2px;
}

.wx-sign-date {
  font-size: 11px;
  color: #7f8894;
}

.wx-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.wx-section-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #1890ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
}

.wx-section-icon svg {
  width: 10px;
  height: 10px;
  fill: #fff;
}

.wx-tips-title {
  font-size: 13px;
  font-weight: 600;
  color: #333333;
}

.wx-tips-content {
  font-size: 12px;
  color: #666;
  line-height: 1.65;
  white-space: pre-line;
  text-indent: 2em;
  text-align: justify;
}

.wx-contact-title {
  font-size: 13px;
  font-weight: 600;
  color: #333333;
}

.wx-contact-company {
  font-size: 12px;
  color: #333;
  margin-bottom: 6px;
}

.wx-contact-line {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.wx-contact-body {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.wx-contact-info {
  flex: 1;
  min-width: 0;
}

.wx-qrcode-box {
  flex: 0 0 76px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
}

.wx-qrcode-placeholder {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  border: 1px dashed #d9d9d9;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="less">
// 只在这个组件内提高 message 组件的 z-index
.ant-message {
  z-index: 3000 !important;
}

// 确保下拉框选项能正确显示
.ant-select-dropdown {
  z-index: 2050 !important;
}

// 确保模态框内的下拉框选项不被遮挡
.ant-modal .ant-select-dropdown {
  z-index: 2050 !important;
}

// 确保日期选择面板不被弹窗遮挡
.ant-calendar-picker-container {
  z-index: 2050 !important;
}
</style>
